var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 34,
    rx: 10,
    fill: "#currentColor",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3172 26.7799L29.1672 23.9272C29.5154 23.579 29.7109 23.1129 29.7109 22.6201C29.7109 22.1272 29.5181 21.6611 29.1672 21.3129L26.1002 18.2406C25.752 17.8924 25.2833 17.6968 24.7904 17.6968C24.2949 17.6968 23.8315 17.8897 23.4806 18.2406L21.0779 20.6406C19.804 20.0938 18.6466 19.3083 17.6681 18.3263C16.6797 17.3433 15.9002 16.1942 15.3484 14.9192L17.7511 12.5192C18.0993 12.1709 18.2949 11.7049 18.2949 11.212C18.2958 10.9689 18.2481 10.7281 18.1548 10.5036C18.0614 10.2792 17.9242 10.0756 17.7511 9.90487L14.6842 6.82987C14.3359 6.48166 13.8672 6.28612 13.3743 6.28612C12.8788 6.28612 12.4154 6.47898 12.0645 6.82987L9.21451 9.67987C8.61986 10.2745 8.27969 11.0942 8.27969 11.9352C8.27969 12.1093 8.29308 12.2781 8.32254 12.4495C8.90647 15.9959 10.7949 19.5156 13.6341 22.3576C16.4788 25.1968 19.9984 27.0826 23.5475 27.6718C24.5547 27.8406 25.5913 27.5031 26.3172 26.7799ZM23.8663 25.7727C20.7083 25.2504 17.5583 23.5522 15.0002 20.9942C12.4422 18.4361 10.744 15.2888 10.2217 12.1308C10.1547 11.7343 10.2886 11.3272 10.5752 11.0379L13.3743 8.2388L16.3449 11.2067L13.1306 14.4156L13.1065 14.4397L13.3208 15.0183C13.9657 16.7725 14.9845 18.3656 16.3063 19.687C17.6282 21.0084 19.2216 22.0266 20.9761 22.6709L21.5547 22.8852L24.7877 19.6495L27.7583 22.6174L24.9592 25.4165C24.6699 25.7058 24.2627 25.8397 23.8663 25.7727Z",
    fill: "#currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7a935ac693511249beea07c10b777191.svg";
export { ForwardRef as ReactComponent };